import {
  createSheetTabParam,
  type SheetTabParam,
} from '@repo/ui/components/molecules/sheet-tabs';
import type { ReferrerArea } from './referrer-area';

/**
 * Schede del dettaglio di commerciale e rivenditore (design «Rete
 * commerciale»): Accordi, Clienti, Commissioni, Anagrafica. La scheda sta
 * sull'URL (`?detailSection=`: `section` è già del dettaglio tenant, con
 * altri valori), così un link o un reload riaprono la stessa.
 */
export const REFERRER_DETAIL_SECTIONS = [
  'agreements',
  'clients',
  'commissions',
  'profile',
] as const;

export type ReferrerDetailSection = (typeof REFERRER_DETAIL_SECTIONS)[number];

export const REFERRER_DETAIL_DEFAULT_SECTION: ReferrerDetailSection =
  'agreements';

export const REFERRER_DETAIL_SECTION_SEARCH_KEY = 'detailSection';

/** Tolti dalla search tornando alla lista. */
export const REFERRER_DETAIL_SEARCH_KEYS = [
  REFERRER_DETAIL_SECTION_SEARCH_KEY,
] as const;

export const REFERRER_DETAIL_SECTION_LABEL_KEYS: Record<
  ReferrerDetailSection,
  string
> = {
  agreements: 'referrers.detail.sections.agreements',
  clients: 'referrers.detail.sections.clients',
  commissions: 'referrers.detail.sections.commissions',
  profile: 'referrers.detail.sections.profile',
};

/**
 * Il rivenditore che guarda un suo agente non ha la scheda Commissioni: le
 * API delle commissioni gli mostrano solo le proprie.
 */
const RESELLER_SECTIONS = ['agreements', 'clients', 'profile'] as const;

const SECTION_PARAMS: Record<
  ReferrerArea,
  SheetTabParam<ReferrerDetailSection>
> = {
  admin: createSheetTabParam(
    REFERRER_DETAIL_SECTIONS,
    REFERRER_DETAIL_DEFAULT_SECTION
  ),
  reseller: restrictTabs(
    createSheetTabParam(RESELLER_SECTIONS, REFERRER_DETAIL_DEFAULT_SECTION)
  ),
};

/** Le schede di un sottoinsieme viste come quelle di tutte le schede. */
function restrictTabs(
  param: SheetTabParam<(typeof RESELLER_SECTIONS)[number]>
): SheetTabParam<ReferrerDetailSection> {
  return {
    tabs: param.tabs,
    defaultTab: param.defaultTab,
    isTab: param.isTab,
    resolve: param.resolve,
    toParam: (tab) => (param.isTab(tab) ? param.toParam(tab) : undefined),
  };
}

export function getReferrerDetailSectionParam(
  area: ReferrerArea
): SheetTabParam<ReferrerDetailSection> {
  return SECTION_PARAMS[area];
}
